import React from 'react';

import StyledGeneralSection from './GeneralSection.styles';
import SettingsSection from './components/SettingsSection/SettingsSection';
import InfoSection from './components/InfoSection/InfoSection';

const GeneralSection: React.FC = () => {
  return (
    <StyledGeneralSection>
      <InfoSection />
      {/* <CommentSection /> */}
      <SettingsSection />
    </StyledGeneralSection>
  );
};

export default GeneralSection;
